import React, { useState } from 'react';
import { Card, Table } from 'antd';
import { observationsColumns } from '../../data/Columns';

const DatastreamsObservations = ({ data }) => {
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

    const handleTableChange = (paginationInfo) => {
        setPagination(paginationInfo);
    };

    const columns = observationsColumns(pagination.current, pagination.pageSize);


    return (
        <Card title="Observations" variant="borderless" style={{ margin: '20px auto' }}>
            <Table 
                columns={columns}   
                dataSource={data?.Observations.map((item, index) => ({ ...item, key: `${item['@iot.id']}` }))} 
                onChange={handleTableChange}
                rowKey={(record) => record['@iot.id']}                
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: data?.Observations?.length,
                }}
                size='middle' 
                scroll={{ x: 300 }} 
            />
        </Card>
    );
};

export default DatastreamsObservations;
